/* @generated from adl module totalinteraction.futurefit.uiconfig */

import * as ADL from './../../runtime/adl';
import * as common_config_log from './../../common/config/log';
import * as common_db from './../../common/db';
import * as totalinteraction_futurefit_db from './db';

/**
 * Configuration for the web frontend.
 */
export interface UiConfig {
  /**
   * Application title
   */
  title: string;
  /**
   * Environment name, e.g. dev, uat, prod
   */
  environment: string;
  /**
   * Name of the release / code version
   */
  releaseName: string;
  /**
   * Client side Rollbar config
   */
  rollbar: (common_config_log.ClientRollbarConfig|null);
  /**
   * Client side auth0 config
   */
  auth0: UiAuth0Config;
  /**
   * AppClient config for the frontend use
   */
  appClient: AppClientConfig;
}

export function makeUiConfig(
  input: {
    title?: string,
    environment: string,
    releaseName: string,
    rollbar?: (common_config_log.ClientRollbarConfig|null),
    auth0: UiAuth0Config,
    appClient: AppClientConfig,
  }
): UiConfig {
  return {
    title: input.title === undefined ? "Welcome to skillseeker" : input.title,
    environment: input.environment,
    releaseName: input.releaseName,
    rollbar: input.rollbar === undefined ? null : input.rollbar,
    auth0: input.auth0,
    appClient: input.appClient,
  };
}

const UiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.uiconfig","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"just","value":"Welcome to skillseeker"},"name":"title","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"environment","default":{"kind":"nothing"},"name":"environment","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"releaseName","default":{"kind":"nothing"},"name":"releaseName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"rollbar","default":{"kind":"just","value":null},"name":"rollbar","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.log","name":"ClientRollbarConfig"}},"parameters":[]}]}},{"annotations":[],"serializedName":"auth0","default":{"kind":"nothing"},"name":"auth0","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.uiconfig","name":"UiAuth0Config"}},"parameters":[]}},{"annotations":[],"serializedName":"appClient","default":{"kind":"nothing"},"name":"appClient","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.uiconfig","name":"AppClientConfig"}},"parameters":[]}}]}},"name":"UiConfig","version":{"kind":"nothing"}}};

export const snUiConfig: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.uiconfig", name:"UiConfig"};

export function texprUiConfig(): ADL.ATypeExpr<UiConfig> {
  return {value : {typeRef : {kind: "reference", value : snUiConfig}, parameters : []}};
}

/**
 * Configuration of Auth0 for the AppClient
 */
export interface UiAuth0Config {
  domain: string;
  clientId: string;
}

export function makeUiAuth0Config(
  input: {
    domain: string,
    clientId: string,
  }
): UiAuth0Config {
  return {
    domain: input.domain,
    clientId: input.clientId,
  };
}

const UiAuth0Config_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.uiconfig","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"domain","default":{"kind":"nothing"},"name":"domain","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"clientId","default":{"kind":"nothing"},"name":"clientId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UiAuth0Config","version":{"kind":"nothing"}}};

export const snUiAuth0Config: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.uiconfig", name:"UiAuth0Config"};

export function texprUiAuth0Config(): ADL.ATypeExpr<UiAuth0Config> {
  return {value : {typeRef : {kind: "reference", value : snUiAuth0Config}, parameters : []}};
}

/**
 * Configuration for the AppClient
 * Add AppClientId to facilitate client-side Admin authorization
 */
export interface AppClientConfig {
  id: common_db.DbKey<totalinteraction_futurefit_db.AppClient>;
  name: string;
  logoUrl: string;
  recommendationsVisible: boolean;
  providerIds: common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>[];
  recreateUserQuizEnabled: boolean;
  walkthroughsEnabled: boolean;
  skipIfAlreadySeen: boolean;
  debugReporting: boolean;
  displayHeadlineRatio: boolean;
  displayHeadlineText: boolean;
  singleTabRecommendations: boolean;
  allowSelfAssessment: boolean;
}

export function makeAppClientConfig(
  input: {
    id: common_db.DbKey<totalinteraction_futurefit_db.AppClient>,
    name: string,
    logoUrl: string,
    recommendationsVisible: boolean,
    providerIds: common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>[],
    recreateUserQuizEnabled: boolean,
    walkthroughsEnabled: boolean,
    skipIfAlreadySeen: boolean,
    debugReporting: boolean,
    displayHeadlineRatio: boolean,
    displayHeadlineText: boolean,
    singleTabRecommendations: boolean,
    allowSelfAssessment: boolean,
  }
): AppClientConfig {
  return {
    id: input.id,
    name: input.name,
    logoUrl: input.logoUrl,
    recommendationsVisible: input.recommendationsVisible,
    providerIds: input.providerIds,
    recreateUserQuizEnabled: input.recreateUserQuizEnabled,
    walkthroughsEnabled: input.walkthroughsEnabled,
    skipIfAlreadySeen: input.skipIfAlreadySeen,
    debugReporting: input.debugReporting,
    displayHeadlineRatio: input.displayHeadlineRatio,
    displayHeadlineText: input.displayHeadlineText,
    singleTabRecommendations: input.singleTabRecommendations,
    allowSelfAssessment: input.allowSelfAssessment,
  };
}

const AppClientConfig_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.uiconfig","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"logoUrl","default":{"kind":"nothing"},"name":"logoUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"recommendationsVisible","default":{"kind":"nothing"},"name":"recommendationsVisible","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"providerIds","default":{"kind":"nothing"},"name":"providerIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProvider"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"recreateUserQuizEnabled","default":{"kind":"nothing"},"name":"recreateUserQuizEnabled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"walkthroughsEnabled","default":{"kind":"nothing"},"name":"walkthroughsEnabled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"skipIfAlreadySeen","default":{"kind":"nothing"},"name":"skipIfAlreadySeen","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"debugReporting","default":{"kind":"nothing"},"name":"debugReporting","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"displayHeadlineRatio","default":{"kind":"nothing"},"name":"displayHeadlineRatio","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"displayHeadlineText","default":{"kind":"nothing"},"name":"displayHeadlineText","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"singleTabRecommendations","default":{"kind":"nothing"},"name":"singleTabRecommendations","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"allowSelfAssessment","default":{"kind":"nothing"},"name":"allowSelfAssessment","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"AppClientConfig","version":{"kind":"nothing"}}};

export const snAppClientConfig: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.uiconfig", name:"AppClientConfig"};

export function texprAppClientConfig(): ADL.ATypeExpr<AppClientConfig> {
  return {value : {typeRef : {kind: "reference", value : snAppClientConfig}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "totalinteraction.futurefit.uiconfig.UiConfig" : UiConfig_AST,
  "totalinteraction.futurefit.uiconfig.UiAuth0Config" : UiAuth0Config_AST,
  "totalinteraction.futurefit.uiconfig.AppClientConfig" : AppClientConfig_AST
};



// WEBPACK FOOTER //
// ./src/adl-gen/totalinteraction/futurefit/uiconfig.ts